import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer";
import BarcodeModal from "../Components/BarcodeScanner";
import EtiquetaCard from "../Components/CardEtiqueta";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
// --- Helpers ---
function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

const parseCurrencyToNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return v;
    const s = String(v).replace(/\./g, "").replace(/,/g, ".");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};

const formatarMoeda = (valor) => {
    if (valor == null || valor === "") return "";
    const numero = parseCurrencyToNumber(valor);
    if (numero === 0) return "R$ 0,00";
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
    }).format(numero);
};

// --- Componente de Loading ---
function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 18 }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 2000;
                }
                .loading-modal-content {
                    background: white;
                    padding: 20px 40px;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 0 10px rgba(0,0,0,0.25);
                }
            `}</style>
        </div>
    );
}

function EtiquetaProduto() {
    const [ean, setEan] = useState("");
    const [selectedEan, setSelectedEan] = useState(null);
    const [produto, setProduto] = useState(null);
    const [showScanner, setShowScanner] = useState(false);
    const [etiquetas, setEtiquetas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [showModal, setShowModal] = useState(false);

    const isScanningRef = useRef(false);
    const isEmittingRef = useRef(false);

    const [lojaSelecionada, setLojaSelecionada] = useState(null);
    const [dentroDoRaio, setDentroDoRaio] = useState(false);

    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const usuario = chapa;

    // Função do Beep
    const audioRef = useRef(new Audio("/beep.mp3"));

    const playBeep = useCallback(() => {
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(e => console.log("Erro ao tocar beep:", e));
    }, []);

    // ADICIONE ESTA AQUI
    const desbloquearAudio = () => {
        if (audioRef.current) {
            audioRef.current.play().then(() => {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }).catch(() => { /* ignora bloqueio */ });
        }
    };

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const { latitude, longitude } = pos.coords;
                    const resp = await api.get("lojas/localizacao");
                    const lojas = resp.data || [];

                    const lojaProxima = lojas.find((loja) => {
                        const distKm = calcularDistancia(
                            latitude,
                            longitude,
                            parseFloat(loja.latitude),
                            parseFloat(loja.longitude)
                        );
                        const distMetros = distKm * 1000;
                        return distMetros <= parseFloat(loja.distancia || 0);
                    });

                    if (lojaProxima) {
                        setLojaSelecionada(lojaProxima);
                        setDentroDoRaio(true);
                    } else {
                        Swal.fire("Atenção", "Você não está dentro do raio de uma loja.", "warning");
                        setDentroDoRaio(false);
                    }
                } catch (err) {
                    Swal.fire("Erro", "Erro ao localizar lojas.", "error");
                }
            },
            (err) => {
                Swal.fire("Erro", "Habilite o GPS para continuar.", "error");
            }
        );
    }, [chapa, navigate]);

    const buscarProduto = async (eanParam = null) => {
        const eanSearch = eanParam ?? ean;
        if (!eanSearch || loading || showModal) return;

        try {
            setLoading(true);
            setLoadingMessage("Consultando produto...");

            // Não fechamos o modal aqui se ele já estiver aberto para evitar "pisca-pisca"
            const resp = await api.get(
                `etiqueta?loja=${lojaSelecionada?.cod_emp}&ean=${encodeURIComponent(eanSearch)}`
            );
            const data = resp.data;

            if (data && data.sucesso === "n") {
                Swal.fire("Atenção", data.erro, "warning");
                return;
            }

            if (!data || Object.keys(data).length === 0) {
                Swal.fire("Atenção", "Produto não cadastrado.", "warning");
                return;
            }

            if (data.statusvenda !== "A") {
                Swal.fire("Atenção", "Produto bloqueado.", "warning");
                return;
            }

            setSelectedEan(eanSearch);
            setProduto({ ...data, ean: eanSearch });
            setShowModal(true);
            setEan(""); // Limpa o input após busca manual
        } catch (err) {
            Swal.fire("Erro", "Erro ao buscar produto.", "error");
        } finally {
            setLoading(false);
        }
    };

    const emitirEtiqueta = async () => {
        if (isEmittingRef.current) return;
        isEmittingRef.current = true;

        const eanToSend = selectedEan || produto?.ean;
        if (!eanToSend) {
            Swal.fire("Atenção", "EAN inválido.", "warning");
            isEmittingRef.current = false;
            return;
        }

        try {
            setLoading(true);
            setLoadingMessage("Emitindo etiqueta...");
            await api.post(
                `etiqueta?ean=${encodeURIComponent(eanToSend)}&loja=${lojaSelecionada?.cod_emp}&usuario=${usuario}`
            );

            // LIMPEZA TOTAL DOS CAMPOS
            setProduto(null);
            setSelectedEan(null);
            setEan("");
            setShowModal(false);

            Swal.fire("Sucesso", "Etiqueta enviada para fila.", "success");
            await carregarEtiquetas();
        } catch (err) {
            Swal.fire("Erro", "Erro ao incluir produto!", "error");
        } finally {
            setLoading(false);
            setTimeout(() => { isEmittingRef.current = false; }, 1000);
        }
    };

    const carregarEtiquetas = async () => {
        try {
            const resp = await api.get(`etiqueta/lista?usuario=${usuario}`);
            setEtiquetas(Array.isArray(resp.data) ? resp.data : []);
        } catch (err) {
            setEtiquetas([]);
        }
    };

    useEffect(() => {
        if (usuario) carregarEtiquetas();
    }, [usuario]);

    const handleScan = (codigo) => {
        // Se o ref for true, ignoramos QUALQUER nova tentativa de leitura
        if (isScanningRef.current) return;

        isScanningRef.current = true; // Bloqueia imediatamente
        playBeep();
        setShowScanner(false);

        // O setTimeout dá um fôlego para o React fechar o modal do scanner
        setTimeout(() => {
            buscarProduto(codigo).finally(() => {
                // Só liberamos o scanner 1.5 segundos depois de terminar a busca
                // Isso evita que o "resto" da leitura do código anterior dispare um novo loop
                setTimeout(() => {
                    isScanningRef.current = false;
                }, 1500);
            });
        }, 100);
    };
    
    {/*const handleScan = (codigo) => {
        if (isScanningRef.current) return;
        isScanningRef.current = true;

        playBeep(); // Toca o som
        setShowScanner(false);

        // Pequeno delay para o modal fechar antes de abrir o próximo (evita travamento visual)
        setTimeout(() => {
            buscarProduto(codigo).finally(() => {
                isScanningRef.current = false;
            });
        }, 300);
    };*/}

    return (
        <div className="d-flex flex-column min-vh-100">
            <Menu modulo="ARBOR" />
            <div className="container-fluid flex-grow-1" style={{ paddingTop: '100px' }}>
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label>Loja</label>
                            <input className="form-control" value={lojaSelecionada?.razao || ""} readOnly />
                        </div>

                        <div className="mb-3">
                            <label>Código de barras</label>
                            <div className="input-group">
                                <input
                                    value={ean}
                                    onChange={(e) => setEan(e.target.value)}
                                    onKeyDown={(e) => e.key === "Enter" && buscarProduto()}
                                    type="text"
                                    className="form-control"
                                    placeholder="Digite ou escaneie"
                                    disabled={!dentroDoRaio || loading}
                                />
                                <button className="btn btn-primary" onClick={() => buscarProduto()} disabled={!dentroDoRaio || !ean || loading}>
                                    <i className="fas fa-search"></i>
                                </button>
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        desbloquearAudio(); // <--- LIBERA O SOM AQUI
                                        setShowScanner(true);
                                    }}
                                    disabled={!dentroDoRaio || loading}
                                >
                                    <i className="fas fa-camera"></i>
                                </button>
                            </div>
                        </div>

                        <h4 className="mt-4">Fila de etiquetas</h4>
                        <div className="row">
                            {etiquetas.map((etq) => (
                                <EtiquetaCard key={etq.etq_sequencia} etq={etq} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={() => {
                setShowModal(false);
                setProduto(null);
                setSelectedEan(null);
            }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes do Produto</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {produto && (
                        <>
                            <img
                                src={`https://cdn-cosmos.bluesoft.com.br/products/${produto.ean}`}
                                alt={produto.desccompleta}
                                className="img-fluid mb-2"
                                style={{ maxHeight: "150px" }}
                                onError={(e) => { e.target.src = "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png"; }}
                            />
                            <div className="mb-2">
                                <div className="fs-3 fw-bold">
                                    {formatarMoeda(produto.promoapp > 0 ? produto.promoapp : (produto.promovarejo > 0 ? produto.promovarejo : (produto.preco ?? produto.precovalidnormal)))}
                                </div>
                            </div>
                            <h5 className="card-title fw-bold">{produto.desccompleta}</h5>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" onClick={emitirEtiqueta} className="w-100" disabled={loading}>
                        Emitir Etiqueta
                    </Button>
                </Modal.Footer>
            </Modal>

            <BarcodeModal
                show={showScanner}
                onClose={() => {
                    setShowScanner(false);
                    // Adicione um pequeno delay para evitar que o fechamento 
                    // do modal seja interpretado como um novo scan
                    setTimeout(() => { isScanningRef.current = false; }, 500);
                }}
                onScanSuccess={handleScan}
            />

            <LoadingModal show={loading} message={loadingMessage} />
            <Footer />
        </div>
    );
}

export default EtiquetaProduto;